import React from 'react';
import { Box, Typography } from '@mui/material';
import RomaneioAlterarDatas from '../components/romaneio/RomaneioAlterarDatas';

const RomaneioAlterarDatasPage: React.FC = () => {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <RomaneioAlterarDatas />
    </Box>
  );
};

export default RomaneioAlterarDatasPage;
